/**
 * Wait for SharedComponents to be available on window object
 * @param {number} maxAttempts - Maximum number of attempts (default: 50)
 * @param {number} interval - Interval between attempts in milliseconds (default: 100)
 * @returns {Promise<object>} Promise that resolves with window.SharedComponents
 * @throws {Error} If SharedComponents are not available after maximum attempts
 */
export async function waitForSharedComponents(maxAttempts = 50, interval = 100) {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if (window.SharedComponents && 
        window.SharedComponents.modalManager && 
        window.SharedComponents.React && 
        window.SharedComponents.ReactDOM) {
      return window.SharedComponents;
    }
    await new Promise(resolve => setTimeout(resolve, interval));
  }
  throw new Error('SharedComponents not available after maximum attempts');
}

